// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Trois carres PLEINS en rangee, largement espaces : le "..." de la rangee 3c
 * au niveau fiche. Memes carres que `IconMenuFull` (meme cote, meme hauteur),
 * la seule difference est le VIDE : environ la moitie du cote ici (second
 * carre a 104.72), environ un cinquieme la-bas (84.65). C'est ce vide double
 * qui le fait lire "et le reste" plutot que "grille".
 *
 * Glyphe tres large (279.15 x 69.72), donc centre dans sa boite carree : a
 * `size` egal il rend une bande d'encre plate, exactement comme le prototype.
 * Source `full_spaced.svg`.
 */
export const IconFullSpaced = createCustomIcon(
  'IconFullSpaced',
  '0 0 279.15 69.72',
  <>
    <path fill="currentColor" d="M0,69.71V0h69.71s0,69.71,0,69.71H0Z" />
    <path fill="currentColor" d="M174.43,0v69.71h-69.71V0h69.71Z" />
    <path fill="currentColor" d="M279.15,0v69.71h-69.71V0h69.71Z" />
  </>,
);
